import { eachDayOfInterval, isWeekend } from 'date-fns';
import { WORKING_DAY } from '../config/timeConstants';

export const calculateReleveRate = (pointages, releveCodes, startDate, endDate) => {
  

  // Calculer le nombre de jours ouvrés sur la période
  const allDays = eachDayOfInterval({ start: startDate, end: endDate });
  const weekdays = allDays.filter(date => !isWeekend(date));
  const totalWorkDays = weekdays.length;

  // Convertir les pointages en jours en utilisant WORKING_DAY
  const workingHoursPerDay = WORKING_DAY.hours + (WORKING_DAY.minutes / 60);

 

  // Grouper les pointages par date et par inclusion dans le taux
  const pointagesByDate = pointages.reduce((acc, pointage) => {
    const date = pointage.date;
    // Chercher le code relève dans les données du pointage
    const releveCodeIncluded = releveCodes.find(rc => rc.id === pointage.releve_code_id)?.include_in_releve_rate;

  

    if (!acc[date]) {
      acc[date] = { includedHours: 0, excludedHours: 0 };
    }
    
    if (releveCodeIncluded) {
      acc[date].includedHours += pointage.hours;
    } else {
      acc[date].excludedHours += pointage.hours;
    }
    
    return acc;
  }, {});

  // Calculer les jours équivalents
  const includedDays = Object.values(pointagesByDate).reduce(
    (sum, { includedHours }) => sum + (includedHours / workingHoursPerDay),
    0
  );

  const excludedDays = Object.values(pointagesByDate).reduce(
    (sum, { excludedHours }) => sum + (excludedHours / workingHoursPerDay),
    0
  );

  // Calculer le taux de relève
  const denominator = totalWorkDays - excludedDays;
  const releveRate = denominator > 0 ? (includedDays / denominator) * 100 : 0;

  // Debug du résultat final
  const result = {
    rate: Math.round(releveRate * 100) / 100,
    includedDays: Math.round(includedDays * 100) / 100,
    excludedDays: Math.round(excludedDays * 100) / 100,
    totalWorkDays
  };

  
  return result;
};
